import { buildProjectPath, buildProposalPath } from 'app/routes/paths/project';

type GetPathForTargetContextParams = {
  pathname: string;
  projectId: string;
  currentProposalId?: string;
  targetProposalId?: string;
};

export const getPathForTargetContext = ({
  pathname,
  projectId,
  currentProposalId,
  targetProposalId
}: GetPathForTargetContextParams) => {
  const currentBasePath = currentProposalId
    ? buildProposalPath(projectId, currentProposalId)
    : buildProjectPath(projectId);

  const targetBasePath = targetProposalId
    ? buildProposalPath(projectId, targetProposalId)
    : buildProjectPath(projectId);

  if (!pathname.startsWith(currentBasePath)) {
    return targetBasePath;
  }

  const suffix = pathname.slice(currentBasePath.length);

  return `${targetBasePath}${suffix}`;
};
